import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getEditorials } from "@lib/api/calls";

export function useEditorials(initialEditorials) {
  const [editorials, setEditorials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    if (editorials.length < 1) {
      setEditorials(initialEditorials.filter((editorial) => editorial.card));

      setLoading(false);
    }
  }, []);

  async function getMoreEditorials() {
    setLoading(true);
    const start = editorials.length + 1;
    // Run query to get additional posts
    try {
      let newEditorials = await getEditorials(false, start, start + 7);
      newEditorials = newEditorials.filter((editorial) => editorial.card);
      if (newEditorials.length == 0 || newEditorials.length < 6) {
        setHasMore(false);
      }
      const newEditorialsList = [...editorials, ...newEditorials];
      setEditorials(newEditorialsList);
      // The result of the console.log is the previous job state
      // Turn off loader
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }
  return { editorials, getMoreEditorials, loading, hasMore };
}

useEditorials.propTypes = { initialEditorials: PropTypes.array.isRequired };
